@if (screenInfo$ | async; as screen) {
  <div style="display: flex; flex-direction: column; height: 100%">
    @if (isLoading) {
      <div
        style="flex: 1 0 100%; min-height: 0; display: flex; flex-direction: column; justify-content: space-between;">
        @if (selectedWidget === 'instrument' || selectedWidget === 'service-history') {
          <sh-tabs id="ms-notifications-tabs-1" style="width: 60%" condensed [collapsed]="screen.size === 'XSmall' || screen.size === 'Small' || screen.size === 'Medium'"
            >
            @for (tab of displayedTabs; track tab.name) {
              <sh-tab-item id="ms-notifications-tab-item-2" disabled [active]="activeTab === tab.name"
              (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
            }
          </sh-tabs>
        }
        <div style="flex: 1; display: flex; align-items: center; justify-content: center;">
          <sh-spinner id="ms-notifications-spinner-3" site="s"></sh-spinner>
        </div>
      </div>
    }
    @if (!isLoading && notifications) {
      <div style="flex: 1; min-height: 0;">
        <p-table [size]="'small'" #table [value]="notifications" [scrollable]="true" scrollHeight="flex"
          [customSort]="true" (sortFunction)="customSort($event)" [sortField]="'age'" [sortOrder]="1" dataKey="id"
          [expandedRowKeys]="expandedRows" [exportFilename]="'notifications'" [columns]="cols">
          <!-- Tools -->
          <ng-template #caption style="border: none;">
            <div style="display: flex; align-items: center; gap: 8px;">
              @if (selectedWidget === 'instrument' || selectedWidget === 'service-history') {
                <sh-tabs id="ms-notifications-tabs-4" style="flex: 1 1 50%;" condensed [collapsed]="screen.size === 'XSmall' || screen.size === 'Small' || screen.size === 'Medium'"
                  >
                  @for (tab of displayedTabs; track tab.name) {
                    <sh-tab-item id="ms-notifications-tab-item-5" [active]="activeTab === tab.name"
                    (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
                  }
                </sh-tabs>
              }
              <div class="table-tools" style="flex: 1 1 50%; gap: 8px; align-items: center;">
                <sh-dropdown id="ms-notifications-dropdown-6" no-border condensed style="min-width: 100px; max-width: 140px;" [attr.value]="(selectedRange === 30 ? 'msNotifications.range.last30Days' : selectedRange === 60 ? 'msNotifications.range.last60Days' : selectedRange === 90 ? 'msNotifications.range.last90Days' : selectedRange === 120 ? 'msNotifications.range.last120Days' : 'msNotifications.range.last120Days') | transloco">
                  <sh-menu-item id="ms-notifications-menu-item-last-30-days" (click)="changeRange(30,'serviceHistory')" [attr.label]="'msNotifications.range.last30Days' | transloco"
                  [active]="selectedRange === 30"></sh-menu-item>
                  <sh-menu-item id="ms-notifications-menu-item-last-60-days" (click)="changeRange(60,'serviceHistory')" [attr.label]="'msNotifications.range.last60Days' | transloco"
                  [active]="selectedRange === 60"></sh-menu-item>
                  <sh-menu-item id="ms-notifications-menu-item-last-90-days" (click)="changeRange(90,'serviceHistory')" [attr.label]="'msNotifications.range.last90Days' | transloco"
                  [active]="selectedRange === 90"></sh-menu-item>
                  <sh-menu-item id="ms-notifications-menu-item-last-120-days" (click)="changeRange(120,'serviceHistory')" [attr.label]="'msNotifications.range.last120Days' | transloco"
                  [active]="selectedRange === 120"></sh-menu-item>
                 
                </sh-dropdown>
                <p-columnFilter style="flex: 0 1 auto; margin-right: -8px;" type="text" [showMenu]="false" field="description"
                  matchMode="contains">
                  <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                    <sh-search id="ms-notifications-search-search-for-issue" no-border [attr.label]="'msNotifications.filter.searchForIssue' | transloco" condensed [(ngModel)]="searchTerm"
                    (ngModelChange)="filter($event)"></sh-search>
                  </ng-template>
                </p-columnFilter>
                <sh-divider id="ms-notifications-divider-12" spacing='s' style="height: 30px;" vertical></sh-divider>
                <span id="download-tooltip-target" style="display: inline-flex; margin-left: -8px;">
                  <sh-icon id="download" button [disabled]="isDownloading || (notifications.length === 0)" [icon]="isDownloading ? 'download-in-progress' : 'download'" size="s" (click)="download()"></sh-icon>
                </span>
                <!-- <sh-tooltip id="ms-notifications-tooltip-13" *ngIf="!isDeviceUI" target="download-tooltip-target" anchor="top" style="max-width: 200px;">
                <sh-text id="ms-notifications-text-14" size="body-2">Download is only available in Device View. We are working on Customer Site Level Notification Download already.</sh-text>
              </sh-tooltip> -->
              <sh-icon id="ms-notifications-icon-15" button icon='refresh' size="s" (click)="refresh()"></sh-icon>
              @if (workareaSize !== 'fullscreen') {
                <sh-icon id="ms-notifications-icon-16" size="xs" [icon]="workareaSize === 'medium' ? 'arrow-face-up-l' : 'arrow-face-down-l'"
                button (click)="onMaximize()" [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
              }
              <sh-icon id="ms-notifications-icon-expand" size="s" [icon]="workareaSize === 'fullscreen' ? 'split-vertically' : 'maximize'" button (click)="onExpand($event)"
              [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
              <sh-icon id="ms-notifications-icon-cancel" icon="cancel" size="s" button (click)="onMinimize()"
              [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
            </div>
          </div>
        </ng-template>
        <!-- Header -->
        <ng-template #header>
          <tr>
            <th pSortableColumn="id" style="min-width:175px;" pFrozenColumn>
              <div style="display: flex; gap: 6px; align-items: center;">
                {{ 'msNotifications.table.notificationId' | transloco }}
                <p-sortIcon field="id" />
              </div>
            </th>
            @if (!isDeviceUI) {
              <th pSortableColumn="serial" style="min-width:150px;" filter filterPlaceholder="Search Serial">
                <div style="display: flex; gap: 6px; align-items: center;">
                  {{ 'msNotifications.table.serialNumber' | transloco }}
                  <p-sortIcon field="serial" />
                </div>
              </th>
            }
            <th pSortableColumn="issue" style="min-width:225px;">
              <div style="display: flex; gap: 6px; align-items: center;">
                {{ 'msNotifications.table.issue' | transloco }}
                <p-sortIcon field="issue" />
              </div>
            </th>
            <th pSortableColumn="age" style="min-width:75px; text-align: right" filter filterPlaceholder="Search Age">
              <div style="display: flex; gap: 6px; align-items: center;">
                {{ 'msNotifications.table.age' | transloco }}
                <p-sortIcon field="age" />
              </div>
            </th>
            <th pSortableColumn="type" style="min-width:75px;">
              <div style="display: flex; gap: 6px; align-items: center;">
                {{ 'msNotifications.table.type' | transloco }}
                <p-sortIcon field="type" />
              </div>
            </th>
            <th pSortableColumn="status" style="min-width:75px;" filter filterPlaceholder="Search Status">
              <div style="display: flex; gap: 6px; align-items: center;">
                {{ 'msNotifications.table.status' | transloco }}
                <p-sortIcon field="status" />
              </div>
            </th>
            <th pSortableColumn="opened" style="min-width:115px; text-align: right">
              <div style="display: flex; gap: 6px; align-items: center;">
                {{ 'msNotifications.table.opened' | transloco }}
                <p-sortIcon field="opened" />
              </div>
            </th>
            <th pSortableColumn="closed" style="min-width:115px; text-align: right" filter filterPlaceholder="Search Closed">
              <div style="display: flex; gap: 6px; align-items: center;">
                {{ 'msNotifications.table.closed' | transloco }}
                <p-sortIcon field="closed" />
              </div>
            </th>
            <th pSortableColumn="visits" style="min-width:100px; text-align: right">
              <div style="display: flex; gap: 6px; align-items: center;">
                {{ 'msNotifications.table.activities' | transloco }}
                <p-sortIcon field="visits" />
              </div>
            </th>
            @if (!businessPartnerMode) {
              <th pSortableColumn="labor" style="min-width:115px; text-align: right" filter filterPlaceholder="Search Labor">
                <div style="display: flex; gap: 6px; align-items: center;">
                  {{ 'msNotifications.table.laborHours' | transloco }}
                  <p-sortIcon field="labor" />
                </div>
              </th>
            }
            <th pSortableColumn="travel" style="min-width:115px; text-align: right">
              <div style="display: flex; gap: 6px; align-items: center;">
                {{ 'msNotifications.table.travelHours' | transloco }}
                <p-sortIcon field="travel" />
              </div>
            </th>
            @if (!businessPartnerMode) {
              <th pSortableColumn="parts" style="min-width:115px; text-align: right" filter filterPlaceholder="Search Parts">
                <div style="display: flex; gap: 6px; align-items: center;">
                  {{ 'msNotifications.table.partsCost' | transloco }}
                  <p-sortIcon field="parts" />
                </div>
              </th>
            }
            <th alignFrozen="right" pFrozenColumn></th>
          </tr>
        </ng-template>
        <ng-template #body let-service let-expanded="expanded">
          <tr>
            <td pFrozenColumn>
              <div style="display: flex; gap: 8px; align-items: center;">
                @if (service.severity!=='Totally Down' && service.status === 'Open') {
                  <sh-icon id="ms-notifications-icon-warning" icon="warning" size="xs" color="var(--warning-yellow)"></sh-icon>
                }
                @if (service.severity!=='Totally Down' && service.status !== 'Open') {
                  <sh-icon id="ms-notifications-icon-success" icon="success" size="xs" color="var(--success-icon-color)"></sh-icon>
                }
                @if (service.severity==='Totally Down' && service.status === 'Open') {
                  <sh-icon id="ms-notifications-icon-error" icon="error" size="xs" color="#E53633"></sh-icon>
                }
                @if (service.severity==='Totally Down' && service.status !== 'Open') {
                  <sh-icon id="ms-notifications-icon-success" icon="success" size="xs" color="var(--success-icon-color)"></sh-icon>
                }
                <span>{{service.id}}</span>
              </div>
            </td>
            @if (!isDeviceUI) {
              <td>{{service.serial_number}}</td>
            }
            <td><span class="truncate-multiline" [innerHTML]="highlight(service.description)"></span></td>
            <td style="text-align: right">{{calculateAge(service.opened_date) + "d"}}</td>
            <td>{{service.type}}</td>
            <td>{{service.status}}</td>
            <td style="text-align: right" >{{service.opened_date?.replace('T',' ')?.replace('Z','')}}
            </td>
            <td style="text-align: right">{{service.closed_date?.replace('T',' ')?.replace('Z','')}}
            </td>
            <td style="text-align: right">{{service.visits}}</td>
            @if (!businessPartnerMode) {
              <td style="text-align: right">{{service.labor.toFixed(2)}}</td>
            }
            <td style="text-align: right">{{service.travel.toFixed(2)}}</td>
            @if (!businessPartnerMode) {
              <td style="text-align: right">{{service.parts_cost.toFixed(2)}}</td>
            }
            <td alignFrozen="right" pFrozenColumn>
              <div style="display: flex; gap: 6px; justify-content: center;">
                <sh-button id="ms-notifications-button-details" compact color="tertiary" [attr.label]="'msNotifications.button.details' | transloco"
                (click)="focusNotification(service.id)"></sh-button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="12">
              @if (!isError) {
                <div
                  style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                  <sh-icon id="ms-notifications-icon-warning" icon="warning" size="s"></sh-icon>
                  <span>{{ 'common.empty.noData' | transloco }}</span>
                </div>
              }
              @if (isError) {
                <div
                  style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
                  <sh-icon id="ms-notifications-icon-error" icon="error" size="s"></sh-icon>
                  <span>{{ 'common.empty.error' | transloco }}</span>
                </div>
              }
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }
</div>
}

